import React from "react";
import { ReactNode } from "react";

export interface Heading2Props {
  heading?: ReactNode;
  heading2?: ReactNode;
  subHeading?: ReactNode;
  className?: string;
  length?: number;
}

const Heading2: React.FC<Heading2Props> = ({
  className = "",
  heading = "",
  heading2 = "",
  subHeading = "",
  length,
}) => {
  return (
    <div className={`mb-2 lg:mb-2 ${className}`}>
      <h2 className="text-xl font-semibold">
        {heading}
        <br />
        {heading2}
      </h2>
      {subHeading ? (
        subHeading
      ) : (
        <span className="block mt-3 text-neutral-500 dark:text-neutral-400">{subHeading}</span>
      )}
    </div>
  );
};

export default Heading2;
